import { updateChatNotification, removeChatNotification } from '../chatSlice'
import { usernotifications } from 'rest/urls'
import { POST, DELETE } from 'rest/request'
import { useReduxDispatch } from 'store'

const useNotificationRequest = () => {
  const dispatch = useReduxDispatch()
  const read = async (id: string) => {
    if (!id) return
    try {
      const response = await POST(`${usernotifications}/${id}/read`)
      if (response?.result === 'ok') {
        dispatch(updateChatNotification({ id, values: { read_date: new Date().toJSON() } }))
      }
    } catch (error) { }
  }

  const remove = async (id: string) => {
    if (!id) return
    try {
      const response = await DELETE(`${usernotifications}/${id}`)
      if (response) {
        dispatch(removeChatNotification({ id }))
      }
    } catch (error) { }
  }

  return {
    read,
    remove
  }
}

export default useNotificationRequest